import * as React from "react";

export const AdminSideBarConfig = [
  {
    id: "home",
    name: "Home",
    header: `${process.env.REACT_APP_NAME}`,
    icon: "icon-home",
    route: "/",
  },
  {
    id: "shops",
    name: "Shops",
    header: "Shops",
    icon: "icon-website",
    route: "/shops",
    subMenu: [
      {
        id: "shop_profile",
        name: "Shop Profile",
        header: "Shop Profile",
        route: "/shops",
      },
    ],
  },
  {
    id: "orders",
    name: "Orders",
    header: "Orders",
    icon: "icon-order",
    route: "/orders",
    subMenu: [
      {
        id: "new_orders",
        name: "New Orders",
        header: "New Orders",
        route: "/orders/new",
      },
      {
        id: "search_orders",
        name: "Search Orders",
        header: "Search Orders",
        route: "/orders/search",
      },
    ],
  },
  {
    id: "products",
    name: "Products",
    header: "Products",
    icon: "icon-product",
    route: "/products",
    subMenu: [
      {
        id: "private_product",
        name: "Products",
        header: "Products",
        route: "/products/private",
      },
      {
        id: "my_categories",
        name: "Categories",
        header: "Categories",
        route: "/products/categories",
      },
      {
        id: "my_products",
        name: "All Products in shop",
        header: "Products in shop",
        route: "/products/all",
      },
      {
        id: "add_product",
        name: "Scan to add common product",
        header: "Branded Products",
        route: "/products/scan",
      },
      {
        id: "search_product",
        name: "Search Common Products",
        header: "Branded Products",
        route: "/products/search",
      },
    ],
  },
  {
    id: "subscriptions",
    name: "Subscriptions",
    header: "Subscription",
    icon: "icon-subscriptions",
    route: "/subscriptions",
    subMenu: [
      {
        id: "my_subscriptions",
        name: "My Subscriptions",
        header: "Subscription",
        route: "/subscriptions",
      },
      {
        id: "all_subscriptions",
        name: "All Subscriptions",
        header: "Subscription",
        route: "/subscriptions/store",
      },
    ],
  },
  {
    id: "account",
    name: "Account",
    header: "Account",
    icon: "icon-home",
    route: "/me",
    subMenu: [
      {
        id: "account_profile",
        name: "Profile",
        header: "Account",
        route: "/me",
      },
      {
        id: "account_media_jobs",
        name: "Media processing",
        header: "Media processing",
        route: "/me/media-jobs",
      },
    ],
  },
];
